import React from "react";
import Footer from "./Footer/Footer";

const Privacy = () => {
    return <>
        <div className="pagebanner" >
            <h2>Privacy Policy</h2>
        </div>
        <div className="policy">
            <h2>Privacy</h2>
            <p>This privacy policy applies only to those activities as specified on Magical Vacation Travel
                and Tourism LLC. By booking with Magical Vacation, you are accepting and consenting to
                the practices and details outlined in this policy.</p>

            <p>The terms "we", "us", "our" and "MagicalVacation" refer to Magical Vacation Travel and Tourism
                LLC, a company incorporated in Dubai, UAE. The term "you" refers to the customer visiting
                the Website and/or booking a reservation through us on this Website, or through our customer
                service agents. By visiting www.magicalvacation.com (the "Website"), you are accepting the
                practices described herein.</p>

            <p>MagicalVacation appreciate your trust in us to handle your personal information with care 
                and caution. Any personal information shared by you which is necessary for processing 
                the booking shall be kept confidential. We will need to use and provide your personal 
                information, which may include each guest’s name, age, birth date, address, phone number, 
                email ID, passport number and additional personal information like religion, health & mobility 
                status, medical history, dietary preferences etc. to process your travel arrangements. 
                This personal information may be passed on to consulates, embassies, visa facilitators, 
                tourism organizations, customs/ immigration authorities, airlines, cruises, railways, 
                hoteliers, marketing & communication service providers for SMS, E-mail, WhatsApp and 
                also for payment-related information. This information will also be used for auditing, 
                research and activities focused to improve the performance of our website.</p>

            <p>In addition to the above, your personal information is subject to disclosure as required by 
                law or by order of the court or enquiry by any government or statutory authority.</p> 

            <p>MagicalVacation will send you sms/ e-mail and make phone calls to update you about your 
                tour status, new launches, promotions, festive offers/ greetings etc. On booking a 
                tour/package, you consent to your personal data being used/ passed on to relevant 
                third parties as mentioned above.</p>       

            <p>Magical Vacation reserves the right to use your testimonials/ emails/ for our promotions on 
                any media without obtaining any consent from you and you agree you shall not be entitled to 
                any payment in respect of such promotions.</p>    

            <p>Magical Vacation shall ensure that all your Information and details related to credit 
                card/ debit card and net banking shall be kept confidential except for the necessary 
                disclosures required by the law and for the proceedings of the tour. All payment 
                transactions on our Website are processed through higher grade encryption when transmitting 
                your payment details. We do not process and do not store sensitive payment information 
                such as your credit/debit card number, cardholder name, and expiry date.</p> 

            <p>Magical Vacation has implemented measures to protect your personal information in our 
                custody and control and we make it a priority to maintain administrative, technical and 
                physical safeguards to protect against unauthorized access, use, modification and disclosure 
                of your personal information. Only our authorized employees are permitted to access personal 
                information, and they may only do so for permitted business functions.</p>  

            <p>However, the collection or communication of information over the Internet or other 
                publicly accessible communications networks cannot be guaranteed to be 100% secure; 
                thus, we cannot ensure warrant or guarantee the security of any such information. 
                You agree and undertake that Magical Vacation will not be liable for any such 
                unauthorized access. The maximum liability of Magical Vacation under any circumstance 
                shall not exceed the value of the services purchased by you.</p>       

            <p>Our website uses a technology called a “Cookie,” which is a small element of data that our 
                website can send to your browser to be stored on your computer so that we can recognize 
                your computer. Cookies may provide us with information that we shall use to personalize 
                our website in accordance with your interests. Note that most website browsers allow you 
                to modify your settings, letting you know when you receive a cookie and allowing you to 
                reject cookies.</p>   

           <p>On Magical Vacation’s Website various third Party vendors also show ads across the Internet. 
            These third party vendors use cookies and other technologies to serve ads based on a user’s 
            prior visits to our website. These cookies and other technologies are used for several purposes, 
            including: to measure the effectiveness of their ads; to analyze, modify, and personalize 
            advertising content on our Website and other sites; and to provide ads about goods and 
            services might be of interest to you. We do not have access to or control over those cookies 
            or other features they may use, and the information practices of these advertisers are not 
            covered by this Privacy Policy.</p>        

           <p>Please note that if you refuse to accept cookies from our Website, you may not be 
            able to access many of the travel tools offered by our Website.</p>   

           <p>If any part of our Website links you to other websites, those websites do not operate 
            under this Privacy Policy. We recommend you examine the privacy statements posted on 
            those other websites to understand their procedures for collecting, using, and disclosing 
            personal information.</p>  

        <p>Magical Vacation Travel and Tourism LLC reserves the right at any time, at our sole discretion, 
            to change this Privacy Policy and any changes will become effective on the day they are posted 
            on our Site. We encourage you to frequently review this Privacy policy for any changes.</p>    
        </div>
        <Footer/>
    </>
}
export default Privacy;